import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { RouteNames } from '../route.name';

const routes: Routes = [
    {
        path: RouteNames.BENUTZERVERWALTUNG,
        loadChildren: () => import('./benutzerverwaltung/benutzerverwaltung.module')
            .then(module => module.BenutzerverwaltungModule)
    },

    {
        path: RouteNames.BUERGSCHAFTEN,
        loadChildren: () => import('./buergschaften/buergschaften.module')
            .then(module => module.BuergschaftenModule)
    },

    {
        path: RouteNames.COCKPIT,
        loadChildren: () => import('./cockpit/cockpit.module')
            .then(module => module.CockpitModule)
    },

    {
        path: RouteNames.DOWNLOADS,
        loadChildren: () => import('./downloads/downloads.module')
            .then(module => module.DownloadsModule)
    },

    {
        path: RouteNames.KUNDENAUSWAHL,
        loadChildren: () => import('./kunden-auswahl/kunden-auswahl.module')
            .then(module => module.KundenAuswahlModule)
    },

    {
        path: RouteNames.POSTEINGANG,
        loadChildren: () => import('./posteingang/posteingang.module')
            .then(module => module.PosteingangModule)
    },

    {
        path: RouteNames.VERTRAEGE,
        loadChildren: () => import('./vertraege/vertraege.module')
            .then(module => module.VertraegeModule)
    },

    {
        path: RouteNames.FIRMENVERBUENDE,
        loadChildren: () => import('./firmenverbuende/firmenverbuende.module')
            .then(module => module.FirmenverbuendeModule)
    },

    {
        path: RouteNames.BASE,
        loadChildren: () => import('./meine-daten/meine-daten.module')
            .then(module => module.MeineDatenModule)
    },
    {
        path: RouteNames.BASE,
        pathMatch: 'full',
        redirectTo: RouteNames.COCKPIT
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InsightRoutingModule {
}
